import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from 'react-hot-toast';

function OtpModal({ show, onClose, email }) {
  const [timer, setTimer] = useState(300); 
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  useEffect(() => {
    let countdown;
    if (show) {
      setTimer(300); 
      countdown = setInterval(() => {
        setTimer((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
      }, 1000);
    }

    return () => clearInterval(countdown);
  }, [show]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const validationSchema = Yup.object().shape({
    otp: Yup.string()
      .required("OTP is required")
      .matches(/^\d{6}$/, "OTP must be 6 digits"),
  });

  const handleSubmit = async (values, { resetForm }) => {
    if (timer === 0) {
      toast.error("OTP expired! Please request a new signup.");
      return;
    }

    try {
      setLoading(true);
      setApiError("");
      const base_url = process.env.REACT_APP_BASE_URL;
      const response = await fetch(`${base_url}/api/auth/verifyOtp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          otp: values.otp, 
          email: email 
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("OTP Verified Successfully!");
        resetForm();
        onClose();
      } else {
        setApiError(data.message || "Invalid OTP, please try again.");
      }
    } catch (error) {
      setApiError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      dialogClassName="signup-modal-full w-100 custom-modal"
      size="md"
    >
      <div className="d-flex w-100">
        <div className="w-100 d-flex flex-column justify-content-between p-4 position-relative bg-white">
          <div>
            <h3 className="mb-2">Enter OTP</h3>

            {/* Timer display */}
            <div className="mb-4 text-end text-muted" style={{ fontSize: "14px" }}>
              Time remaining: <strong>{formatTime(timer)}</strong>
            </div>

            <Formik
              initialValues={{ otp: "" }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="mb-3">
                    <label className="mb-2">Enter OTP</label>
                    <Field
                      name="otp"
                      type="text"
                      maxLength="6"
                      className="form-control text-center"
                      placeholder="Enter 6-digit OTP"
                    />
                    <ErrorMessage
                      name="otp"
                      component="div"
                      className="text-danger"
                    />
                    {apiError && <div className="text-danger mt-2">{apiError}</div>}
                  </div>

                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      type="button"
                      onClick={onClose}
                      className="btn login-btn text-white position-relative overflow-hidden"
                      style={{ fontSize: "18px", fontFamily: "inherit" }}
                    >
                      <div className="swift-btn_animation d-flex justify-content-center align-items-center log_cus">
                        <p className="m-0 text-black">Close</p>
                      </div>
                    </button>

                    <button
                      type="submit"
                      className="btn signup-btn text-white position-relative overflow-hidden border-0"
                      disabled={loading || isSubmitting}
                    >
                      <div
                        className="swift-btn_animation d-flex justify-content-center align-items-center"
                        style={{ background: "radial-gradient(circle,rgb(0, 0, 0),rgb(0, 0, 0))" }}
                      >
                        <p className="m-0 text-black fw-bold button_name">
                          {loading ? "Verifying..." : "Verify"}
                        </p>
                      </div>
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default OtpModal;
